import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TenantState {
  tenantId: number | null;
  serverRootAddress: string | null;
  formattedCode: string | null;
  currentTenant: { tenantId: number | null; serverRootAddress: string | null } | null;
  setTenant: (tenantId: number, serverRootAddress: string, formattedCode?: string) => void;
  clearTenant: () => void;
  hasValidTenant: () => boolean;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set, get) => ({
      tenantId: null,
      serverRootAddress: null,
      formattedCode: null,
      currentTenant: null,

      setTenant: (tenantId: number, serverRootAddress: string, formattedCode?: string) => {
        set({ 
          tenantId, 
          serverRootAddress, 
          formattedCode: formattedCode || null,
          currentTenant: { tenantId, serverRootAddress }
        });
      },

      clearTenant: () => {
        set({ tenantId: null, serverRootAddress: null, formattedCode: null, currentTenant: null });
      },

      hasValidTenant: () => {
        const { tenantId, serverRootAddress } = get();
        return !!tenantId && !!serverRootAddress;
      },
    }),
    {
      name: 'tenant-storage',
    }
  )
);